import React from "react";
import { useSelector } from "react-redux";
import { ReactComponent as ArrowIcon } from "../../inlineSvgs/arrow-right.svg";
import { ReactComponent as BagIcon } from "../../inlineSvgs/bag-2.svg";
import { Link } from "react-router-dom";

const CheckoutButton = () => {
  const curentService = useSelector((state) => state.orderReducer.selectedCatService);
  const screen = useSelector((state) => state.userReducer.screen);
  return (
    curentService && (
      <Link className="checkout-button" to={screen.desktop ? "/booking/service" : "/booking"}>
        <div>
          <BagIcon />
          <div className="text">
            <div className="title">1 Service</div>
            <div className="sub-title">Go to master & date selection...</div>
          </div>
        </div>
        <ArrowIcon />
      </Link>
    )
  );
};

export default CheckoutButton;
